import ReactDOM from 'react-dom';

import './index.css';
import './fonts/fonts.css'
import App from './App';

import { AuthProvider, useFirebaseApp } from 'reactfire';
import { getAuth } from 'firebase/auth';

// ReactFire setup
import { FirebaseAppProvider } from 'reactfire';
const firebaseConfig = {
	apiKey: 'AIzaSyAyN-3QmXsfN-ZY4rSIUUXjqvktaB1XVXE',
	authDomain: 'journal-app-f8587.firebaseapp.com',
	projectId: 'journal-app-f8587',
	storageBucket: 'journal-app-f8587.appspot.com',
	messagingSenderId: '321378491024',
	appId: '1:321378491024:web:0c1021aba0e8cddc499615',
	measurementId: 'G-CSHGW6H1RW'
}

ReactDOM.render(
	<FirebaseAppProvider firebaseConfig={firebaseConfig}>
		<AuthElement></AuthElement>
	</FirebaseAppProvider>,
	document.getElementById('root')
)

function AuthElement() {
	const firebaseApp = useFirebaseApp();
	const auth = getAuth(firebaseApp);
	return (
		<AuthProvider sdk={auth}>
			<App />
		</AuthProvider>
	)
}